const KEY = 'myaudience:steam-punk-records:v2';
/** Explicit device-only saves, separate modes, bounded history and truthful storage errors.
 * No original score API, account identifiers or automatic imports are used. */
export function installSteamRecords(r, storage = () => localStorage) {
  let memory = [];
  const read = () => {
    try {
      const value = JSON.parse(storage().getItem(KEY) || '[]');
      return Array.isArray(value)
        ? value
            .filter(
              (x) =>
                x &&
                ['classic', 'speed', 'timed'].includes(x.mode) &&
                Number.isSafeInteger(x.score) &&
                x.score >= 0 &&
                typeof x.name === 'string' &&
                Number.isFinite(x.createdAt),
            )
            .slice(0, 250)
        : [];
    } catch {
      return memory;
    }
  };
  r.createRunId = () => crypto.randomUUID();
  r.sanitizePlayerName = (value) =>
    String(value || '')
      .replace(/[^a-zA-Z0-9 -]/g, '')
      .slice(0, 12);
  r.hideScoreboard = () => {
    r.ui.scoreboard.hidden = true;
  };
  r.renderScoreboard = () => {
    const { game, ui } = r;
    const now = new Date();
    const starts = {
      all: 0,
      month: new Date(now.getFullYear(), now.getMonth(), 1).getTime(),
      day: new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime(),
      hour: new Date(now.getFullYear(), now.getMonth(), now.getDate(), now.getHours()).getTime(),
    };
    starts.week = starts.day - ((now.getDay() + 6) % 7) * 86400000;
    const rows = read()
      .filter(
        (x) => x.mode === game.scoreboardBoardMode && x.createdAt >= starts[game.scoreboardRange],
      )
      .sort((a, b) => b.score - a.score || a.createdAt - b.createdAt)
      .slice(0, 25);
    ui.scoreboardList.replaceChildren();
    for (const row of rows) {
      const li = document.createElement('li');
      li.textContent = `${row.name || 'You'} · ${row.score.toLocaleString()} points · Level ${row.level}`;
      ui.scoreboardList.append(li);
    }
    if (!rows.length) {
      const li = document.createElement('li');
      li.textContent = 'No saved records yet. Play privately, then choose Save.';
      ui.scoreboardList.append(li);
    }
    for (const tab of [...ui.scoreboardTabs, ...ui.scoreboardModeTabs]) {
      const active = tab.dataset.boardRange
        ? tab.dataset.boardRange === game.scoreboardRange
        : tab.dataset.boardMode === game.scoreboardBoardMode;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', String(active));
    }
  };
  r.prepareGameOverScoreboard = () => {
    r.game.scoreboardBoardMode = r.game.mode;
    r.ui.scoreboard.hidden = false;
    r.ui.scoreboardEntry.hidden = false;
    r.ui.saveScore.disabled = r.game.scoreSavedForRun || r.game.score <= 0;
    r.ui.scoreboardStatus.textContent =
      'Private result. Save on this shared device only if you choose.';
    r.renderScoreboard();
  };
  r.openHighScores = () => {
    r.pause();
    r.game.scoreboardMode = 'view';
    r.ui.overlay.classList.add('is-visible');
    r.ui.primary.textContent = 'Close records';
    r.ui.overlayTitle.textContent = 'Your records';
    r.ui.overlayCopy.textContent =
      'Only this myAudience browser. Separate from Prometheus. No upload.';
    r.ui.modeSelect.hidden = true;
    r.ui.scoreboard.hidden = false;
    r.ui.scoreboardEntry.hidden = true;
    r.renderScoreboard();
    r.ui.primary.focus();
  };
  r.saveCurrentScore = () => {
    if (r.game.status !== 'gameover' || r.game.scoreSavedForRun || r.game.score <= 0) return;
    const rows = [
      ...read(),
      {
        mode: r.game.mode,
        score: Math.floor(r.game.score),
        level: r.game.level,
        name: r.sanitizePlayerName(r.ui.playerName.value),
        createdAt: Date.now(),
      },
    ]
      .sort((a, b) => b.createdAt - a.createdAt)
      .slice(0, 250);
    try {
      storage().setItem(KEY, JSON.stringify(rows));
      memory = rows;
      r.game.scoreSavedForRun = true;
      r.ui.saveScore.disabled = true;
      r.ui.scoreboardStatus.textContent = 'Saved on this device only.';
      r.renderScoreboard();
    } catch {
      r.ui.scoreboardStatus.textContent =
        'Device storage unavailable. Your result is still here; nothing was saved.';
    }
  };
  r.clearRecords = () => {
    try {
      storage().removeItem(KEY);
      memory = [];
      r.renderScoreboard();
      r.ui.scoreboardStatus.textContent = 'Device records cleared.';
    } catch {
      r.ui.scoreboardStatus.textContent = 'Could not clear device records. Please try again.';
    }
  };
}
